
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import { RespuestaPredefinida } from '@/__env/lib/Preguntas/RespuestaPredefinida';
    import { isNullOrUndefined } from 'util';
    import { Utiles } from '@/__env/pluggins/event-bus';
import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;

        @Prop()
        public Respuesta: RespuestaPredefinida;

        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {
            this.Abierto = false;
            this.$nextTick( () =>
            {
                if ( this.Respuesta )
                {
                    if ( this.Respuesta.Existe )
                    {
                        this.Predefinida = new RespuestaPredefinida( this.Respuesta.Json );
                        //this.Predefinida.Titulo = this.Respuesta.Titulo;
                        //this.Predefinida.Color = this.Respuesta.Color;
                        //this.Predefinida.Respuesta = this.Respuesta.Respuesta;
                    }
                    else
                    {
                        this.Predefinida = new RespuestaPredefinida();
                    }
                    this.Abierto = true;
                }
            } );
        }

        public Predefinida: RespuestaPredefinida = null;
        public Abierto: boolean = false;
        public Cargando: boolean = false;

        public get Ok()
        {
            return !isNullOrUndefined( this.Predefinida ) &&
                this.Predefinida.Respuesta &&
                this.Predefinida.Titulo &&
                this.Predefinida.Color;
        }

        async Guardar()
        {
            if ( this.Predefinida )
            {
                this.Cargando = true;
                let e = await this.Predefinida.save();
                if ( e )
                {
                    this.$emit( 'recargar' );
                    await Wait(100);
                    Utiles.Notificaciones.Completado( 'Guardado correctamente!' );
                    this.Cerrar();
                } else
                {
                    Utiles.Notificaciones.Error( 'Error al guardar' );
                }
            }
            this.Cargando = false;
        }

        Cerrar()
        {
            this.Predefinida = null;
            this.Abierto = false;
        }
    }
